// Module
var code = "<div id=\"preloader\" class=\"col-md-6 col-md-offset-3 text-center\">\r\n\r\n    <br>\r\n    <br>\r\n    <br>\r\n\r\n    <div class=\"cbp-loader\"></div>\r\n    <h3 data-bind=\"restext: 'RetrievingData'\"></h3>\r\n\r\n</div>";
// Exports
export default code;